import { Component } from 'react';
import { Spinner } from 'vtex.styleguide';

const style = {
  display: 'flex',
  justifyContent: 'center',
  padding: '100px',
  width: '100%',
}

export default class Loading extends Component {
  render() {
    return (
      <div style={style}>
        <Spinner/>
      </div>
    )
  }
}
